import { Link, usePathname } from "expo-router";
import { StyleSheet, View } from "react-native";

import { usePlatform } from "@/session/platform";
import { makeStyles } from "@/theme/makeStyles";
import { PressableTarget } from "@/ui/PressableTarget";
import { Text } from "@/ui/Text";

import { parentSections, sectionForPath } from "../chrome/sections";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    nav: { flexDirection: "row", alignItems: "stretch", gap: t.space.xs },
    link: {
      height: t.size.headerHeightDesktop,
      paddingHorizontal: t.space.md,
      borderBottomWidth: t.size.navUnderline,
      borderBottomColor: "transparent",
    },
    active: { borderBottomColor: t.color.primary },
  }),
);

/**
 * Desktop header links Home / Shop / Orders / Profile (FR-006, FR-045; board WebHome): real links
 * (`<a>` on the web), the current one marked with aria-current="page" and a 3 px primary underline.
 */
export function DesktopNav() {
  const styles = useStyles();
  const pathname = usePathname();
  const onWeb = usePlatform() === "web";
  const current = sectionForPath(pathname);
  return (
    <View style={styles.nav} role="navigation" aria-label="Main">
      {parentSections.map((section) => {
        const isCurrent = current?.name === section.name;
        const currentProps =
          onWeb && isCurrent ? { "aria-current": "page" as const } : {};
        return (
          <Link key={section.name} href={section.href} asChild>
            <PressableTarget
              accessibilityRole="link"
              accessibilityLabel={section.label}
              // Flat object: Link asChild merges styles with an object spread (expo/expo#31352).
              style={StyleSheet.flatten([
                styles.link,
                isCurrent && styles.active,
              ])}
              {...currentProps}
            >
              <Text
                variant="heading"
                weight="semiBold"
                size="base"
                tone={isCurrent ? "default" : "muted"}
                style={{ textTransform: "lowercase" }}
              >
                {section.label}
              </Text>
            </PressableTarget>
          </Link>
        );
      })}
    </View>
  );
}
